























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import * as firebase from 'firebase';
import utility from '@/utility/utility';
import commentServices from '@/services/comment-services';
import { Comment } from '@/models/comment';
import { APP_CONFIG } from '@/config/app-config'
@Component
export default class ChatBox extends Vue {
    @Prop({default: 0})
    private orderId!: number;

    @Prop({default: 1})
    private orderType!: number;
    private hasImage = false;
    private imageData: any = null;
    private uploadValue = 100;
    private comment: string = '';
    private listComment: Comment[] = [];
    private timer: any;

    private isBlockEnter = false;

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    private async created() {
        this.timer = setInterval(() => {
            this.loadComment();
        }, APP_CONFIG.notifyRefreshTime * 1000);
    }

    private async destroyed() {
        clearInterval(this.timer);
    }

    @Watch('orderId', { immediate: true, deep: true })
    private async loadComment() {
        if(document.hidden) {
            return;
        }
        if (this.orderId > 0) {
            const result: any = await commentServices.getComment(this.orderId, this.orderType);
            if(result && result.data.status === 200 && result.data.message === 'Success') {
                const arrComment: any = [];
                for (const item of result.data.data) {
                    arrComment.push({
                        ...item,
                        CreatedDate: moment(item.CreatedDate).format('DD-MM-YYYY hh:mm:ss')
                    });
                }

                this.listComment = arrComment;
            }
            this.setScroll();
        }
    }

    private onCommentKeyup(e: any) {
        if(e.keyCode === 13) {
            e.preventDefault();
            this.addComment();
        }
    }
    
    private async addComment() {
        if (this.comment.trim().length > 0 && this.isBlockEnter === false) {
            this.isBlockEnter = true;
            const commentModel: Comment = {
                OrderID: this.orderId,
                Comment: this.comment,
                Status: 1,
                Type: 1,
                OrderType: this.orderType,
                CustomerID: this.$store.state[APP_CONFIG.stateKey.authStore].userInfo.userId
            };
            const result = await commentServices.addComment(commentModel);
            this.comment = '';
            this.isBlockEnter = false;
            if (result.data.status === 200) {
                this.loadComment();
            }
        }
    }

    private setScroll() {
        setTimeout(() => {
            const boxMess: any = this.$el.querySelector('.content-message');
            boxMess.scrollTop = boxMess.scrollHeight;
        }, 0);
    }

    private async addFile() {
        if (this.$refs.fileInput instanceof HTMLElement) {
            this.$refs.fileInput.click();
        }
    }

    private async onUpload(e) {
        const file = e.target.files[0];
        this.uploadFile(file);
    }

    private async uploadFile(file) {
        const arrFileType = file.name.split('.');
        const extType = arrFileType[arrFileType.length - 1];
        if (['jpg','png','jpeg','doc','docx','pdf','xls','xlsx','zip'].indexOf(extType) === -1) {
            Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'File không đúng định dạng!',
                });
            return;
        }
        const storageRef=firebase.storage().ref(`${APP_CONFIG.settings.firebase_prefix}/msg/${utility.randomString(35)}.${extType}`).put(file);
        storageRef.on(`state_changed`, snapshot => {
                this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
            },
            error => {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'Lỗi upload, kích thước file tối đa 10Mb!',
                });
            },
            () => {
                this.uploadValue=100;
                storageRef.snapshot.ref.getDownloadURL().then(async (url) => {
                    const commentModel: Comment = {
                        OrderID: this.orderId,
                        Comment: url,
                        Status: 1,
                        Type: 1,
                        OrderType: this.orderType,
                        CustomerID: this.$store.state[APP_CONFIG.stateKey.authStore].userInfo.userId,
                        Media: ['jpg','png','jpeg'].indexOf(extType) >= 0 ? 1 : 2,
                        FileName: file.name
                    };
                    const result = await commentServices.addComment(commentModel);
                    this.comment = '';
                    this.isBlockEnter = false;
                    if (result.data.status === 200) {
                        this.loadComment();
                    }
                });
            }
        );
    }

    private async onPaste(event) {
        const clipboardData = event.clipboardData || window['clipboardData'];
        const items = clipboardData.items;
        for (const item of items) {
            if (item.type.indexOf('image') !== -1) {
                const imageFile = item.getAsFile();
                this.uploadFile(imageFile);
            }
        }
    }
}
